import { InjectionToken } from '@angular/core';
import type { app } from 'firebase-admin';
import type { Firestore } from 'firebase-admin/firestore';

/**
 * Injection token to use Firebase Admin SDK on server/pre-rendered routes.
 */
export const FIREBASE_ADMIN = new InjectionToken<app.App | null>(
  'firebase-admin',
);

export const FIRESTORE = new InjectionToken<Firestore>(
  'firebase-admin/firestore',
);
